import React from 'react';

import { strings } from '../../../localization/strings';
import Badge from '../badge';

export default function YesNoBadge({ state }: { state: boolean }) {
  return <Badge status={state ? 'success' : 'danger'} text={state ? strings.common.yes : strings.common.no} />;
}
